module.exports = __webpack_public_path__ + "img/blanco.47fc7554.jpg";